import { render } from "./enrollment-box.vue?vue&type=template&id=7fd20132&scoped=true"
import script from "./enrollment-box.vue?vue&type=script&lang=js"
export * from "./enrollment-box.vue?vue&type=script&lang=js"

import "./enrollment-box.vue?vue&type=style&index=0&id=7fd20132&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd20132"]])

export default __exports__